import { TherapySession } from './interfaces';

type TherapySessionWithScalarAssociations = TherapySession & {
    therapistId?: unknown;
};

// Recognize every supported Client and Team association shape before showing fallback history.
export function hasExplicitSessionParticipantAssociation(session: TherapySession): boolean {
    const sessionWithScalars = session as TherapySessionWithScalarAssociations;
    const hasScalarAssociation = [session.clientId, sessionWithScalars.therapistId]
        .some((personId) => typeof personId === 'string' && !!personId.trim());
    const hasArrayAssociation = [session.clientIds, session.therapistIds]
        .some((personIds) => Array.isArray(personIds) && personIds.some(
            (personId) => typeof personId === 'string' && !!personId.trim()
        ));
    const hasTypedParticipant = Array.isArray(session.participants) && session.participants.some(
        (participant) => !!participant &&
            (participant.personType === 'client' || participant.personType === 'therapist') &&
            typeof participant.personId === 'string' && !!participant.personId.trim()
    );

    return hasScalarAssociation || hasArrayAssociation || hasTypedParticipant;
}
